// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import propertyData from "pages/Home/sections/data/propertyData";

function LocationInfo() {
  const { address, city, state, country, coordinates } = propertyData.location;
  const mapSrc = `https://www.google.com/maps/embed/v1/place?key=AIzaSyDKm-MtSZ1fH1xkgbM6Q9mnmh64zOlEsqg&q=${coordinates.lat},${coordinates.lng}&zoom=12`;

  return (
    <MKBox component="section" py={6} id="location">
      <Container>
        <MKTypography variant="h3" mb={4}>
          Location
        </MKTypography>
        <Grid container spacing={4}>
          <Grid item xs={12} lg={5}>
            <MKBox mb={3}>
              <MKTypography variant="h5" display="flex" alignItems="center" mb={1}>
                <Icon color="info" sx={{ mr: 1 }}>
                  place
                </Icon>
                Location
              </MKTypography>
              <MKTypography variant="body1" color="text" pl={4}>
                {address}
                <br />
                {city}, {state}, {country}
              </MKTypography>
            </MKBox>

            <MKBox mb={3}>
              <MKTypography variant="h5" display="flex" alignItems="center" mb={1}>
                <Icon color="info" sx={{ mr: 1 }}>
                  flight
                </Icon>
                Getting Here
              </MKTypography>
              <MKTypography variant="body2" color="text" pl={4} mb={0.5}>
                Juan Santamar&iacute;a International Airport (SJO) — 1.5 hr drive
              </MKTypography>
              <MKTypography variant="body2" color="text" pl={4} mb={0.5}>
                Jac&oacute; town center — 9 miles south
              </MKTypography>
              <MKTypography variant="body2" color="text" pl={4}>
                SUVs for rent during your stay
              </MKTypography>
            </MKBox>

            <MKBox mb={3}>
              <MKTypography variant="h5" display="flex" alignItems="center" mb={1}>
                <Icon color="info" sx={{ mr: 1 }}>
                  explore
                </Icon>
                Nearby Attractions
              </MKTypography>
              <MKTypography variant="body2" color="text" pl={4} mb={0.5}>
                Jac&oacute; Beach — 9 miles
              </MKTypography>
              <MKTypography variant="body2" color="text" pl={4} mb={0.5}>
                Carara National Park, Crocodile bridge — 15 min drive
              </MKTypography>
              <MKTypography variant="body2" color="text" pl={4} mb={0.5}>
                Surfing, zip-lining, ATV, waterfall tours - all nearby
              </MKTypography>
              <MKTypography variant="body2" color="text" pl={4}>
                Manuel Antonio National Park — 1.8 hr drive
              </MKTypography>
            </MKBox>
          </Grid>

          <Grid item xs={12} lg={7}>
            <MKBox
              component="iframe"
              src={mapSrc}
              width="100%"
              height="55%"
              sx={{ border: 0, aspectRatio: "1 / 1" }}
              borderRadius="xl"
              shadow="md"
              allowFullScreen
              loading="lazy"
              title="Property Location"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default LocationInfo;
